module.exports = __webpack_public_path__ + "static/media/uib9.46a6aedb.png";